import { PropsWithChildren } from 'react';

type WorkspaceFormFieldProps = { label: string; isVisible?: boolean };

const WorkspaceFormField = ({ label, children, isVisible = true }: PropsWithChildren<WorkspaceFormFieldProps>) => {
  if (!isVisible) return null;

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">{label}</label>
      {children}
    </div>
  );
};

export default WorkspaceFormField;
